export const loaderMixin = {
    methods: {
        present_info(text) {
            this.dismiss_loader();
            this.$swal.fire({
                html: `<span>${text}</span>`,
                showConfirmButton: true,
                icon: "success",
            });
        },
        present_error(text) {
            this.dismiss_loader();
            this.$swal.fire({
                html: `<span>${text}</span>`,
                showConfirmButton: true,
                icon: "error",
            });
        },
        present_success(title = "Sucesso!", text) {
            this.$swal.fire(title, text, "success");
        },
        present_loader(text) {
            this.dismiss_loader();
            this.$swal.fire({
                html: `<div style="display:flex;align-items:center;justify-content:center;"><div style="border:4px solid #f3f3f3;border-top:4px solid #3085d6;border-radius:50%;width:40px;height:40px;animation:spin 1s linear infinite;margin-right:15px;"></div><span>${text}</span></div><style>@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style>`,
                showCancelButton: false,
                showConfirmButton: false,
            });
        },
        dismiss_loader() {
            this.$swal.close();
        },
        loader_msg(msg) {
            this.$swal.update({
                html: `<div style="display:flex;align-items:center;justify-content:center;"><div style="border:4px solid #f3f3f3;border-top:4px solid #3085d6;border-radius:50%;width:40px;height:40px;animation:spin 1s linear infinite;margin-right:15px;"></div><span>${msg}</span></div><style>@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}</style>`,
            });
        },
        confirm_action(params) {
            this.$swal
                .fire({
                    title: params.message,
                    text: params.subtitle,
                    icon: "question",
                    showCancelButton: !params.hide_cancel_button && true,
                    denyButtonText: params.deny_text,
                    showDenyButton: params.deny_text,
                    confirmButtonColor: "#3085d6",
                    heightAuto: false,
                    cancelButtonColor: params.cancel_buttom_color || "#d33",
                    confirmButtonText: params.confirm_text || "Sim, continuar!",
                    cancelButtonText: params.cancel_text || "Cancelar!",
                })
                .then((result) => {
                    if (result.value) {
                        params.callback();
                    }
                    if (result.isDenied) {
                        params.deny_callback(result);
                    }
                });
        },
    },
};
